export const PAGE_HEADER_SEARCH_RECT_ID = 'pageHeader_search';
